module.exports = __webpack_public_path__ + "media/images/flags/IT-7af9cfcdc8dfbb983132b1bce61873c5.svg";